<div style="padding: 20px; margin-bottom: 10px;">
    <form [formGroup]="merchantIssueForm" (ngSubmit)="onSubmit()">
        <div class="card-body card ng-untouched ng-pristine ng-invalid">
            <!-- <div class="fw-600" style="font-size: 25px;">{{ merchantIssue?.issueTitle }}</div>
            <div class="justify-content-between d-flex" style="width: 40%; padding: 10px;">
                <span *ngIf="merchantIssue?.issueStatus === 0" class="badge badge-green">Open</span>
                <span *ngIf="merchantIssue?.issueStatus === 1" class="badge badge-grey">Close</span>
                <span>Created At: {{ getFormattedDate(merchantIssue?.createdAt) }}</span>
                <span>Updated At: {{ getFormattedDate(merchantIssue?.updatedAt) }}</span>
            </div>
            <div class="d-flex justify-content-end mt-3">
                <button *ngIf="merchantIssue?.issueStatus === 0" class="btn btn-danger" (click)="onSubmit()">Close
                    Issue</button>
                <button *ngIf="merchantIssue?.issueStatus === 1" class="btn btn-success" (click)="onSubmit()">Reopen
                    Issue</button>
            </div> -->
            <div class="d-flex justify-content-between align-items-center mb-1">
                <div class="fw-600" style="font-size: 25px; padding-left:10px" [title]="merchantIssue?.issueTitle"> {{
                    (merchantIssue?.issueTitle.length > 50
                    ? (merchantIssue?.issueTitle | slice : 0 : 47) + "..."
                    : (merchantIssue?.issueTitle | titlecase)) | translate | async
                    }}
                </div>                
            <div>
                    <button type="button" *ngIf="merchantIssue?.issueStatus === 0" class="btn btn-black"
                        (click)="closeIssue()">Close Ticket</button>
                    <button type="button" *ngIf="merchantIssue?.issueStatus === 1" class="btn btn-black"
                        (click)="reopenIssue()">Reopen Ticket</button>
                </div>
            </div>
            <div class="justify-content-between d-flex" style="width: 40%; padding: 10px;">
                <span *ngIf="merchantIssue?.issueStatus === 0" class="badge badge-green">Open</span>
                <span *ngIf="merchantIssue?.issueStatus === 1" class="badge badge-grey">Close</span>
                <span>Created At: {{ getFormattedDate(merchantIssue?.createdAt) }}</span>
                <span>Updated At: {{ getFormattedDate(merchantIssue?.updatedAt) }}</span>
            </div>
            <!-- <div class="mt-3">
                <div class="mb-1 row d-flex">
                    <div class="col-sm-2 fw-bold" style="font-size: 18px;">Description</div>
                </div>
                <div class="row mb-3" style="margin-left: -10px;">
                    <div class="">
                        <span class="" style="margin-right: 0px;">{{ merchantIssue?.description }}</span>
                    </div>
                </div>
            </div> -->
            <div class="mt-3 description-container">
                <div class="mb-1 row d-flex">
                    <div class="col-sm-2 fw-bold" style="font-size: 18px;">Description</div>
                </div>
                <div class="row mb-3" style="margin-left: -10px;">
                    <div class="description-text">
                        <p class="" [innerHTML]="merchantIssue?.description"></p>
                        <!-- <span>{{ merchantIssue?.description }}</span> -->
                    </div>
                </div>
            </div>
        </div>
        <div>

            <div class="mb-1 card-body card ng-untouched ng-pristine ng-invalid">
                <div class="col-sm-2 fw-bold" style="font-size: 18px;" >Attachment
                    <i class="f-10 fas fa-info-circle vertical-align-super" #popoverTriggerName="ngbPopover"
                    [ngbPopover]="'Attachment Allowd Max Size 5 MB.' | translate | async"
                    triggers="mouseenter:mouseleave" [popoverTitle]="'Attachment' | translate | async" placement="right"></i></div>
                <table style="width: 1035px; margin-left: 10px; margin-top: 10px; margin-bottom: 10px;">
                    <tr>
                        <th>Thumbnail</th>
                        <th>File Name</th>
                        <th>Action</th>
                    </tr>
                    <tr *ngFor="let attachment of merchantIssue?.attachments" class="attachment-row">
                        <td class="attachment-preview">
                            <ng-container
                                *ngIf="attachment.endsWith('.jpg') || attachment.endsWith('.png') || attachment.endsWith('.jpeg'); else notImage">
                                <!-- Image Preview -->
                                <img src="{{ attachment }}" alt="Image Preview" style="width: 50px; height: 50px;">
                            </ng-container>
                            <ng-template #notImage>
                                <ng-container
                                    *ngIf="attachment.endsWith('.mp4') || attachment.endsWith('.mov'); else otherFile">
                                    <!-- Video Thumbnail (assuming a placeholder image or frame preview) -->
                                    <video width="100" height="100" controls>
                                        <source src="{{ attachment }}" type="video/mp4">
                                        Your browser does not support the video tag.
                                    </video>
                                </ng-container>
                                <ng-template #otherFile>
                                    <ng-container *ngIf="attachment.endsWith('.pdf')">
                                        <!-- PDF Preview: Usually a generic PDF icon -->
                                        <img src="assets/images/exclimg.png" alt="PDF Preview"
                                            style="width: 50px; height: 50px;">
                                    </ng-container>
                                    <ng-container *ngIf="attachment.endsWith('.otherFormats'); else defaultPreview">
                                        <!-- Handling other specific formats if needed -->
                                    </ng-container>
                                    <ng-template #defaultPreview>
                                        <!-- Default file icon for unknown formats -->
                                        <img src="assets/images/exclimg.png" alt="File Preview"
                                            style="width: 50px; height: 50px;">
                                    </ng-template>
                                </ng-template>
                            </ng-template>
                        </td>
                        <td class="attachment-link">
                            <!-- Assuming attachment.fileName is the property where the file name is stored -->
                            <a href="{{ attachment }}" target="_blank">{{ attachment }}</a>
                        </td>
                        <td>
                            <button type="button" class="btn btn-sm" (click)="removeAttachment(attachment)">
                                <img src="/assets/images/small/delete.svg" alt="archive" />
                            </button>
                        </td>
                    </tr>
                </table>
                <div style="padding-top: 20px;"></div>
                <ngx-dropzone (change)="onFilesAdded($event)" style="height:140px; border:1px dashed; width:720px;"
                [accept]="'image/*,video/*,audio/*,.xls,.xlsx'">
                    <ngx-dropzone-label>
                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <img src="../../../../assets/images/uplode-menu.png" class="mb-3" style="width: 50px" />
                            <div class="fs-6 text-dark fw-bold">
                                <p class="mb-0 fw-500">{{ "Drop files here or click to upload" | translate | async }}
                                </p>
                            </div>
                        </div>
                    </ngx-dropzone-label>
                    <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemoveFile(f)">
                        <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                    </ngx-dropzone-preview>
                </ngx-dropzone>
            </div>
        </div>

        <div class="card-body card ng-untouched ng-pristine ng-invalid">
            <div class="mb-1 row d-flex">
                <div class="col-sm-2 fw-bold" style="font-size: 18px;">Comments</div>
            </div>
            <div class=" mb-3">
                <ng-container *ngIf="merchantIssue?.comments?.length > 0; else noComments">
                    <!-- <ng-container *ngFor="let comment of merchantIssue?.comments; let i = index">
                        <div class="ctext-wrap" *ngIf="i < 3 || showAllComments">
                            <span class="fw-600">{{ comment.employeeName + " "}}</span>
                            <span class="text-muted fw-500"> Posted On: {{ getFormattedDate(comment.createdAt) }}</span>
                            <div [innerHTML]="comment.comments"></div>
                            <br>
                        </div>
                    </ng-container> -->
                    <ng-container *ngIf="merchantIssue?.comments?.length > 0; else noComments">
                        <ng-container *ngFor="let comment of merchantIssue?.comments; let i = index">
                            <div class="ctext-wrap" *ngIf="i < 3 || showAllComments">
                                <div class="chat-bubble">
                                    <div class="chat-content">
                                        <h5 class="chat-name">{{ comment.employeeName }}</h5>
                                        <p class="chat-message" [innerHTML]="comment.comments"></p>
                                        <p class="chat-time" style="margin-bottom: 0rem;"><i
                                                class="bx bx-time-five align-middle me-1"></i> {{
                                            getFormattedDate(comment.createdAt) }}</p>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <button *ngIf="merchantIssue?.comments.length > 3 && !showAllComments" class="btn btn-link"
                        (click)="showAllComments = true">Show all comments</button>
                </ng-container>
                <ng-template #noComments>
                    <div class="list-group-item">No comments added</div>
                </ng-template>
            </div>
        </div>
        <div class="comment-form-container card-body card ng-untouched ng-pristine ng-invalid">
            <form [formGroup]="commentForm" (ngSubmit)="addComment()">
                <ckeditor [editor]="Editor" formControlName="commentText" (ready)="onReady($event)" tagName="textarea"
                    [(ngModel)]="editorContent" id="classic-editor" name="classic-editor" (change)="onChange($event)"
                    (focus)="onFocus($event)" (blur)="onBlur($event)" [config]="{
            placeholder: 'Please Describe the Issue...',
            toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'blockQuote', '|', 'undo', 'redo']
          }">
                </ckeditor>
                <div class="d-flex justify-content-start mt-3" style="margin-left: 10px;">
                    <button type="submit" class="btn btn-black" [ngClass]="{'btn-disabled': !commentForm.valid}"
                        [disabled]="!commentForm.valid">Add Comment</button>
                </div>
            </form>
        </div>
    </form>
</div>